import React from 'react';
import Article from '../../components/common/Article-container';
import "../pages.css";
import VerifiedUsersList from "../../components/common/VerifiedUsersList";


const Copyright = () => {
    return (
        <div className='main'>
            <div className="page-container">
                <Article className="page-title" title="Copyright Notice">
                    <p>© 2025 Girijananda Chowdhury University Alumni Website. All Rights Reserved.
                    <br />
                    This website and its content, including but not limited to text, graphics, logos, and design, are the intellectual property of Girijananda Chowdhury University and its alumni network unless otherwise stated. Unauthorized use, reproduction, distribution, or modification of any material on this site without prior written permission is strictly prohibited.
                    <br />
                    For inquiries regarding content usage or permissions, please contact us at alumni@gcuniversity.ac.in.
                    <br />
                    By accessing and using this website, you agree to comply with our terms of use and privacy policies.</p>
                </Article>            
            </div>
        </div>
    )
}

const Disclaimer = () => {
    return (
        <div className='main'>
            <div className="page-container">
                <Article title="Disclaimer">
                    <p>Last Updated: 8th March, 2025
                    <br />
                    The Girijananda Chowdhury University Alumni Website ("Website") is an independent platform designed to facilitate communication and networking among alumni. By using this Website, you acknowledge and agree to the following:
                    <br />
                    1. General Information
                    The content on this Website is provided for informational and networking purposes only.
                    While we strive to ensure accuracy, we do not guarantee that all information is up-to-date, complete, or error-free.
                    <br />
                    2. No Endorsement or Liability
                    This Website may contain links to third-party websites or external resources. We do not endorse or take responsibility for the accuracy, legality, or content of external sites.
                    The views, opinions, and content shared by users or alumni do not necessarily reflect the views of Girijananda Chowdhury University.
                    <br />
                    3. Limitation of Liability
                    The Website administrators, university, and affiliated individuals are not responsible for any direct, indirect, incidental, or consequential damages resulting from the use of this Website.
                    Users are solely responsible for any actions taken based on the content found on this platform.
                    <br />
                    4. No Professional Advice
                    Any discussions, opinions, or information shared on this Website do not constitute professional, legal, financial, or academic advice. Users should consult appropriate professionals for specific concerns.
                    <br />
                    5. Changes to This Disclaimer
                    We reserve the right to modify or update this Disclaimer at any time without prior notice. Continued use of the Website constitutes acceptance of the revised terms.
                    <br />
                    6. Contact Information
                    For any questions regarding this Disclaimer, please contact us at alumni@gcuniversity.ac.in. </p>
                </Article>
            </div>
        </div>
    )
}

const ContactUs = () => {
    return (
        <div className='main'>
            <div className="page-container">
                <Article title="ContactUs">
                    <p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nihil dolorem veritatis debitis similique quos! Provident rerum quibusdam qui inventore molestiae, optio dolorem minus. Similique beatae accusamus nihil ut distinctio in error ipsum neque sint a, itaque totam vitae ipsa? Quos quod incidunt tempore laboriosam, minus nesciunt modi error amet veritatis, excepturi reiciendis qui saepe explicabo id doloremque et. Aspernatur cupiditate consectetur nobis iusto libero quisquam debitis, corrupti incidunt quibusdam aut ullam praesentium reprehenderit dicta tempore quasi explicabo minima? Molestiae fugit nam a, possimus unde minima autem voluptatum. Alias doloribus dicta voluptatibus aliquam. Accusantium odio id hic quos nesciunt ab consequuntur, blanditiis mollitia numquam necessitatibus. Molestiae repellendus qui sunt recusandae! Harum pariatur veritatis quia neque similique iusto et modi magnam dolor esse quibusdam quod voluptas, necessitatibus, nulla, laboriosam earum. Ducimus aliquid quae est incidunt id alias velit, consequuntur quod facere culpa quisquam accusantium quos sed dignissimos minima deserunt fugiat ratione accusamus? </p>
                </Article>
            </div>
        </div>
    )
}


const TermsOfUse = () => {
    return (
        <div className='main'>
            <div className="page-container">
                <Article title="Terms of Use">
                    <p>Effective Date: 8th March, 2025
                    <br />
                    Welcome to the Girijananda Chowdhury University Alumni Website. By accessing or using this website, you agree to abide by the following terms and conditions. If you do not agree, please refrain from using the site.
                    <br />
                    1. Purpose of the Website
                    This website is created for the alumni of Girijananda Chowdhury University to connect, network, share updates, and engage in university-related discussions.
                    <br />
                    2. User Responsibilities
                    You must provide accurate and truthful information while registering or contributing to the website.
                    Any form of harassment, abuse, or offensive content is strictly prohibited.
                    You agree not to post spam, advertisements, or any promotional content without prior permission.
                    Do not share sensitive or confidential information that violates privacy laws.
                    <br />
                    3. Intellectual Property
                    All content, including logos, text, images, and graphics, is owned by Girijananda Chowdhury University or its contributors and is protected under copyright laws.
                    You may not copy, modify, distribute, or reproduce any content without prior authorization.
                    <br />
                    4. User-Generated Content
                    By posting content (comments, images, discussions), you grant us a non-exclusive right to use, modify, or display it on the website.
                    We reserve the right to remove any content that violates these terms.
                    <br />
                    5. Privacy & Data Usage
                    We respect user privacy and will not share personal information without consent.
                    By using this site, you agree to our data collection practices as outlined in our Privacy Policy.
                    <br />
                    6. Termination of Access
                    We reserve the right to suspend or terminate user access at our discretion if these terms are violated.
                    <br />
                    7. Changes to Terms
                    We may update these terms from time to time. Continued use of the website after changes means you accept the updated terms.
                    <br />
                    8. Contact Information
                    For any queries regarding these terms, please contact us at alumni@gcuniversity.ac.in. </p>
                </Article>
            </div>
        </div>
    )
}

const PrivacyPolicy = () => {
    return (
        <div className='main'>
            <div className="page-container">
                <Article title="Privacy Policy">
                    <p>Effective Date: 8th March, 2025
                    <br />
                    At Girijananda Chowdhury University Alumni Website, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you visit and interact with our website.
                    <br />
                    <br />
                    1. Information We Collect
                    <br />
                    We may collect the following types of information:

                    Personal Information: Name, email address, phone number, graduation details, and other profile-related data when you register.
                    Usage Data: Information on how you interact with the website, including IP addresses, browser type, and pages visited.
                    User-Generated Content: Posts, comments, and other contributions made to the platform.
                    <br />
                    2. How We Use Your Information
                    <br />
                    We use your information for the following purposes:

                    To provide and maintain the alumni network.
                    To personalize your experience and improve website functionality.
                    To communicate updates, newsletters, and event invitations.
                    To monitor website security and prevent unauthorized access.
                    <br />
                    3. Sharing of Information
                    <br />
                    We do not sell or rent your personal data. However, we may share it in the following cases:

                    With authorized university representatives for alumni-related activities.
                    If required by law, in response to legal requests or government authorities.
                    With third-party service providers who help us manage the website (e.g., hosting providers).
                    <br />
                    4. Data Security
                    <br />
                    We implement security measures to protect your personal information, but we cannot guarantee absolute security due to the nature of online platforms. Users are encouraged to use strong passwords and safeguard their accounts.
                    <br />
                    5. Cookies & Tracking Technologies
                    <br />
                    We may use cookies to enhance user experience, track website activity, and improve functionality. You can disable cookies in your browser settings if you prefer.
                    <br />
                    6. Third-Party Links
                    <br />
                    This website may contain links to third-party sites. We are not responsible for their privacy policies or content, and users should review their policies before providing any information.
                    <br />
                    7. Your Rights & Choices
                    <br />
                    You have the right to:
                    <br />
                    Access, update, or delete your personal data.
                    Opt-out of marketing communications.
                    Request clarification on how your data is used.
                    <br />
                    8. Changes to This Policy
                    <br />
                    We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated Effective Date.
                    <br />
                    9. Contact Us
                    <br />
                    If you have any questions or concerns about this Privacy Policy, please contact us at alumni@gcuniversity.ac.in. </p>
                </Article>
            </div>
        </div>
    )
}

const AlumniDirectory = () => {
    return (
        <div className='main'>
        <>
            <VerifiedUsersList/>
        </>
        </div>
    )
}

export {Copyright, Disclaimer, ContactUs, TermsOfUse, PrivacyPolicy, AlumniDirectory};
